import React from 'react';
import '../../config/style.css';
import logo from '../../assets/images/logos/main_inverse.png';
import { Typography } from '@material-ui/core';
import LazyImage from '../common/LazyImage';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { NavLink } from 'react-router-dom';
import { preserveTrackingParams } from '../../utils/hubspotTracking';

const Footer = () => {
    const socialLinks = [
        { href: 'https://twitter.com/Data_Connector', Icon: TwitterIcon, label: 'Twitter' },
        { href: 'https://www.facebook.com/people/Data-Connector/100087590074644/', Icon: FacebookIcon, label: 'Facebook' },
        { href: 'https://www.youtube.com/channel/UCEnfdp6oD53m5hKhdPm5Zrw', Icon: YouTubeIcon, label: 'YouTube' },
        { href: 'https://www.linkedin.com/company/dataconnector', Icon: LinkedInIcon, label: 'LinkedIn' },
    ];

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer__container">
                <div className="footer__main">
                    <div className="footer__brand">
                        <LazyImage
                            src={logo}
                            alt="Data Connector"
                            width={100}
                            height={100}
                            sizes="100px"
                            className="footer__logo"
                        />
                        <NavLink to={preserveTrackingParams('/register-company')} className="footer__cta">
                            Start free trial
                        </NavLink>
                    </div>

                    <div className="footer__columns">
                        <div className="footer__col">
                            <span className="footer__heading">Product</span>
                            <nav className="footer__links" aria-label="Product links">
                                <NavLink to="/platform" className="footer__link">Platform</NavLink>
                                <NavLink to="/pricing" className="footer__link">Pricing</NavLink>
                                <NavLink to="/integrations" className="footer__link">Integrations</NavLink>
                                <NavLink to="/connectors" className="footer__link">Connectors</NavLink>
                            </nav>
                        </div>
                        <div className="footer__col">
                            <span className="footer__heading">Resources</span>
                            <nav className="footer__links" aria-label="Resources links">
                                <NavLink to="/blog" className="footer__link">Blog</NavLink>
                                <NavLink to="/documentation" className="footer__link">Documentation</NavLink>
                                <NavLink to="/support" className="footer__link">Support</NavLink>
                                <NavLink to="/security" className="footer__link">Security</NavLink>
                            </nav>
                        </div>
                        <div className="footer__col">
                            <span className="footer__heading">Legal</span>
                            <nav className="footer__links" aria-label="Legal links">
                                <NavLink to="/terms" className="footer__link">Terms</NavLink>
                                <NavLink to="/privacy" className="footer__link">Privacy</NavLink>
                                <NavLink to="/cookie-policy" className="footer__link">Cookie policy</NavLink>
                                <NavLink to="/data-deletion" className="footer__link">Data deletion</NavLink>
                            </nav>
                        </div>
                    </div>
                </div>

                <div className="footer__bottom">
                    <Typography component="span" className="footer__copyright">
                        &copy; {new Date().getFullYear()} Data Connector. All rights reserved.
                    </Typography>
                    <div className="footer__social" role="list" aria-label="Social links">
                        {socialLinks.map(({ href, Icon, label }) => (
                            <a
                                key={label}
                                href={href}
                                className="footer__social-link"
                                target="_blank"
                                rel="noreferrer"
                                aria-label={label}
                                role="listitem"
                            >
                                <Icon fontSize="small" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
